import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { publicApi } from '../services/api';
import { useAuth } from '../services/AuthContext';
import toast from 'react-hot-toast';
import { ArrowLeft, Send } from 'lucide-react';

export default function VacationForm() {
  const { user, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [restaurants, setRestaurants] = useState([]);
  const [submitting, setSubmitting] = useState(false);
  const [form, setForm] = useState({
    employee_name: '',
    employee_code: '',
    restaurant: '',
    preferred_weeks: '',
    additional_notes: '',
  });

  useEffect(() => {
    publicApi.getRestaurants().then(r => setRestaurants(r.data)).catch(() => {});
    // Pre-fill if logged in
    if (isAuthenticated && user) {
      setForm(f => ({
        ...f,
        employee_name: `${user.first_name} ${user.last_name}`,
        employee_code: user.employee_code || '',
      }));
    }
  }, [isAuthenticated, user]);

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    if (!form.employee_name || !form.preferred_weeks) {
      toast.error('Rellena los campos obligatorios.');
      return;
    }
    setSubmitting(true);
    try {
      await publicApi.submitVacation({
        ...form,
        restaurant: form.restaurant || null,
      });
      toast.success('Solicitud de vacaciones enviada correctamente.');
      navigate('/');
    } catch (err) {
      const msg = err.response?.data?.error || 'Error al enviar la solicitud.';
      toast.error(msg);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="new-employee-section">
      <div className="new-employee-card">
        <button onClick={() => navigate('/')} className="btn btn--ghost" style={{ marginBottom: 20 }}>
          <ArrowLeft size={16} /> Volver
        </button>
        <div className="card card--elevated animate-in">
          <h2 className="card__title" style={{ fontSize: '1.3rem', marginBottom: 8 }}>
            Solicitud de Vacaciones
          </h2>
          <p style={{ color: 'var(--gray-500)', marginBottom: 24, fontSize: '0.9rem' }}>
            Rellena tus datos y las semanas preferidas para tus vacaciones.
          </p>

          <form onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label>Nombre completo *</label>
                <input
                  className="form-input"
                  name="employee_name"
                  value={form.employee_name}
                  onChange={handleChange}
                  placeholder="Tu nombre completo"
                  required
                />
              </div>
              <div className="form-group">
                <label>Código de empleado</label>
                <input
                  className="form-input"
                  name="employee_code"
                  value={form.employee_code}
                  onChange={handleChange}
                  placeholder="Ej: 1194-15"
                />
              </div>
            </div>

            <div className="form-group">
              <label>Restaurante</label>
              <select className="form-input" name="restaurant" value={form.restaurant} onChange={handleChange}>
                <option value="">Selecciona restaurante</option>
                {restaurants.map(r => (
                  <option key={r.id} value={r.id}>{r.name} ({r.code})</option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label>Semanas preferidas de vacaciones *</label>
              <textarea
                className="form-input"
                name="preferred_weeks"
                value={form.preferred_weeks}
                onChange={handleChange}
                placeholder="Indica las semanas que prefieres para tus vacaciones. Ej: Semana del 14 al 21 de julio, semana del 4 al 11 de agosto..."
                rows={4}
                required
              />
            </div>

            <div className="form-group">
              <label>Notas adicionales</label>
              <textarea
                className="form-input"
                name="additional_notes"
                value={form.additional_notes}
                onChange={handleChange}
                placeholder="Cualquier información adicional relevante"
                rows={3}
              />
            </div>

            <button type="submit" className="btn btn--primary btn--lg" disabled={submitting} style={{ width: '100%' }}>
              <Send size={16} />
              {submitting ? 'Enviando...' : 'Enviar solicitud'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
